<template>
    <sub-page class="m-addPaper m-addTheoryPaper">

        <el-steps class="step-title" :active="active" finish-status="success" simple style="padding: 12px 20%;">
            <div class="click-zone" @click="toStep(0)"></div>
            <div class="click-zone" @click="toStep(1)"></div>
            <el-step :title="$t('course.addBaseInfo')" icon="el-icon-edit"></el-step>
            <el-step :title="$t('paper.startPaper')" icon="el-icon-tickets"></el-step>
        </el-steps>

        <transition enter-active-class="animated slideInRight">

            <div class="step-box step-1" v-show="active === 0">
                <el-form :model="ruleForm"
                         :rules="rules"
                         ref="ruleForm"
                         :label-width="$i18n.locale === 'zh-CN' ? '100px': '140px'"
                         class="paper-form">
                    <el-row class="paper-form-row">
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('paper.name')+'：'" prop="name">
                                <el-input v-model="ruleForm.name" :placeholder="$t('tip.paperName')" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('topic.passLine')+'：'" prop="passLine">
                                <el-input-number v-model.number="ruleForm.passLine" controls-position="right"
                                          :min="0.1" :max="1" :precision="2" :step="0.1"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="paper-form-row">
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('c.knowledgePoint')+'：'" prop="knowledge">
                                <el-cascader ref="knowledge"
                                    v-model="ruleForm.knowledge"
                                    :options="knowledgeMenu['Theory']"
                                    :props="cascadeProp"
                                    :placeholder="$t('tip.knowledgePoint')"
                                    :show-all-levels="false"
                                    @change="knowledgeChange"
                                    filterable
                                ></el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('c.operatorLevel')+'：'" prop="forLevel">
                                <el-select v-model="ruleForm.forLevel" collapse-tags :placeholder="$t('tip.operatorLevel')">
                                    <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                                               :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('c.difficulty')+'：'" prop="difficulty">
                                <el-select v-model="ruleForm.difficulty" :placeholder="$t('tip.difficulty')">
                                    <el-option :label="item.value" :value="item.id" v-for="item in difficultyDict"
                                               :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <div v-if="!paperId" class="paper-method">
                    <h2 class="title"><span>{{$t('tip.paperGroupType')}}</span></h2>
                    <div class="choose">
                        <el-tooltip
                            v-for="item in methodInfo"
                            class="item"
                            effect="dark"
                            :content="item.tooltip"
                            placement="bottom"
                            :key="item.prop"
                            transition="el-fade-in-linear"
                        >
                            <div class="choose-item" @click="method = item.prop" :class="{'active': method === item.prop}">
                                <h3>{{item.name}}</h3>
                                <span :class="item.prop"></span>
                            </div>
                        </el-tooltip>
                    </div>
                </div>

                <div class="btn-group">
                    <el-button type="primary" @click="nextStep('ruleForm')"
                               style="padding: 14px 50px;font-size: 18px;">{{$t('c.next')}}
                    </el-button>
                </div>
            </div>
        </transition>

        <transition enter-active-class="animated slideInLeft">
            <div class="step-box step-2" v-show="active === 1">

                <component
                    :is="componentName"
                    :isImport="isImport"
                    @last-step="lastStep"
                    :passLine="ruleForm.passLine"
                    :paperName="ruleForm.name"
                    :knowledgeName="ruleForm.knowledge"
                    :kpName="knowledgeName"
                    :forLevel="ruleForm.forLevel"
                    :difficulty="ruleForm.difficulty"
                    :editData="editData"
                    @needUpdate="needUpdate"
                ></component>

            </div>
        </transition>

    </sub-page>
</template>

<script>
    import SubPage from '@/components/Subpage.vue';
    import addTheoryByAuto from './Theory/AddTheoryByAuto'
    import addTheoryByManual from './Theory/AddTheoryByManual'
    import addTheoryGraphic from './Theory/AddTheoryGraphic'
    import {mapGetters} from 'vuex';
    import { Cascade } from '@/utils';
    import api from '@/api';

    export default {
        components: {
            SubPage,
            addTheoryByAuto,
            addTheoryByManual,
            addTheoryGraphic
        },

        props: ['paperId'],

        data() {
            let validatePass = (rule, value, callback) => {
                if (value > 1 || value < 0) {
                    return callback(new Error('及格线取值范围是0~1'));
                }
                callback();
            };
            return {
                active: 0,
                method: '',
                methodInfo: [{
                    prop: 'Auto',
                    name: this.$t('paper.buildupSmart'),
                    tooltip: this.$t('paper.randomGenPaper')
                }, {
                    prop: 'Manual',
                    name: this.$t('paper.buildupChoose'),
                    tooltip: this.$t('paper.chooseGenPaper')
                }, {
                    prop: 'Import',
                    name: this.$t('paper.buildupImport'),
                    tooltip: this.$t('paper.importGenPaper')
                }],
                isImport: false,
                ruleForm: {
                    name: '',
                    knowledge: [],
                    forLevel: '',
                    difficulty: '',
                    passLine: 0.6,
                },
                knowledgeName:'',
                editData: '',
                difficultyDict: [],
                rules: {
                    name: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    knowledge: [
                        {required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change'}
                    ],
                    forLevel: [
                        {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                    ],
                    difficulty: [
                        {required: true, message: this.$t('tip.difficulty'), trigger: 'change'}
                    ],
                    passLine: [
                        {type: 'number', required: true, message: this.$t('tip.passLine'), trigger: 'blur'},
                        {validator: validatePass, trigger: 'blur'}
                    ],
                },
                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },
            }
        },
        created() {
            this.$store.dispatch('getForLevelMenu');

            // 拿到知识点之后再去加载数据
            this.$store.dispatch('getKnowledgeMenu', {
                type: 'Theory'
            }).then(data => {
                if (this.paperId) this.initData();
            });

            api.getDifficulty().then(res => {
                this.difficultyDict = res.package;
            });

            if (this.$route.query.fromMap) {
                this.active = 1
            }
        },
        computed: {
            ...mapGetters([
                'forLevelMenu',
                'knowledgeMenu'
            ]),
            componentName() {
                if (this.method === 'Auto') {
                    return 'addTheoryByAuto';
                } else if (this.method === 'Manual') {
                    this.isImport = false;
                    return 'addTheoryByManual';
                } else if (this.method === 'Import') {
                    this.isImport = true;
                    return 'addTheoryByManual';
                } else if (this.method === 'Image') {
                    return 'addTheoryGraphic';
                }
            },
        },
        methods: {
            initData() {

                api.getTheoryPaperDetail(this.paperId).then(res => {
                    this.editData = res.package;

                    /**
                     * 2020/9/1 新增“快速判断题”和“位置标记题”这两种“理论图片题”
                     */
                    if (this.editData.method === 5) {
                        this.method = 'Image';
                    } else {
                        this.method = 'Manual';
                    }

                    this.ruleForm = {
                        name: this.editData.title,
                        knowledge: Cascade.fullPath(this.knowledgeMenu['Theory'], this.editData.knowledge),
                        forLevel: this.editData.forLevel,
                        difficulty: this.editData.difficulty,
                        passLine: this.editData.passLine,
                    }
                });
            },

            isValid() {
                let bool = true;

                if (this.active === 0) {
                    this.$refs['ruleForm'].validate((valid) => {
                        if (!valid) {
                            bool = false;
                            return;
                        }

                        if (!this.method && !this.paperId) {
                            this.$message({
                                message: this.$t('tip.paperGroupType') + '！',
                                type: 'error'
                            });
                            bool = false;
                        }
                    });
                }

                return bool;
            },
            toStep(n) {
                if (this.isValid()) {
                    this.active = n;
                }
            },
            lastStep() {
                this.active--;
            },
            nextStep() {
                if (this.isValid()) {
                    this.active++;
                }
            },

            //知识点变化
            knowledgeChange(data){
                this.ruleForm.knowledge = data;
                setTimeout(()=>{
                    this.knowledgeName =this.$refs.knowledge.presentText
                },0)
            },

            closeFn() {
                if (this.paperId) {
                    this.$router.replace({name: 'myPaper'});
                    return;
                }

                this.$confirm(this.$t('m.paperingOrExit'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.$router.replace({name: 'myPaper'});
                }).catch(() => {
                });
            },

            needUpdate() {
                this.$emit('needUpdate');
            }
        },
        watch: {
            active(val, oldVal) {

                if (val === 0) {
                    this.$store.dispatch('getKnowledgeMenu', {
                        type: 'Theory'
                    });
                } else if (val === 2) {
                    if (this.method === 'Auto') {
                        this.$store.dispatch('getKnowledgeMenu', {
                            type: 'Theory'
                        });
                    } else {
                        this.$store.dispatch('getKnowledgeMenu', {
                            type: 'All'
                        });
                    }
                }
            },
        },
    }
</script>

<style lang="scss">
@import "./AddPaper";
</style>
